export function scoreTone(score) {
  if (score == null) return 'bg-gray-500/10 text-gray-300 border-gray-500/20';
  if (score >= 80) return 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20';
  if (score >= 60) return 'bg-amber-500/10 text-amber-300 border-amber-500/20';
  return 'bg-red-500/10 text-red-300 border-red-500/20';
}

export function scoreLabel(score) {
  if (score == null) return '—';
  if (score >= 80) return 'Pass';
  if (score >= 60) return 'Warn';
  return 'Fail';
}

export const SEVERITY_TONE = {
  critical: 'bg-red-500/15 text-red-300 border-red-500/25',
  serious:  'bg-amber-500/15 text-amber-300 border-amber-500/25',
  moderate: 'bg-yellow-500/10 text-yellow-300 border-yellow-500/20',
  minor:    'bg-gray-500/10 text-gray-400 border-gray-500/20',
};
